export const appConfig = {
  allowCrawling: true,
  NEXT_PUBLIC_BASE_URL: 'https://www.foochia.com', // process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.NEXT_PUBLIC_BASE_URL
  NEXT_PUBLIC_API_BASE_URL: 'https://be-app.foochia.com', // process.env.NEXT_PUBLIC_API_BASE_URL
  ONE_SIGNAL_APP_ID: 'f9d8ad8c-ced2-4f0e-944d-6799fdc85839',
  brandName: 'فوشيا',
  googleNewsUrl: 'https://news.google.com/publications/CAAqJQgKIh9DQklTRVFnTWFnMEtDMlp2YjJOb2FXRXVZMjl0S0FBUAE?hl=ar&gl=AE&ceid=AE:ar',
  appStoreUrl: 'https://apps.apple.com/ae/app/foochia/id6499256363',
  googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.eremmedia.foochia&pcampaignid=web_share'
}